import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { fromJS } from 'immutable';
import { routerMiddleware } from 'connected-react-router/immutable';
import { responsiveStoreEnhancer } from 'redux-responsive';
import { searchParamsDTO } from 'src/store/enqueue/enqueueDTO';

import { getViewInitialState } from 'src/store/view/reducer';
import { isSSR } from 'src/helpers/ssr';
import { isWebGlSupported } from 'src/utils/mapUtils';
import reducer from './reducers';
import sagas from './sagas';
import { REVIEWS_DEFAULT_VISIBLE } from '../constants/reviews';

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers =
  (!isSSR && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];

const getStore = (props, history) => {
  const {
    logo,
    menu,
    hotel,
    isMobile,
    reviews,
    breadcrumbs,
    ratings,
    images,
    availableSearchTypes,
    search_params,
    requestId,
    pagination,
  } = props;

  const preloadedState = {
    logo,
    menu,
    view: {
      isMobile,
      isShortInfoClamped: true,
      page: null,
      availableSearchTypes: availableSearchTypes || undefined,
      isWidgetShown: true,
      isWebGlSupported: isWebGlSupported(),
      ...getViewInitialState(),
    },
    breadcrumbs,
    hotel,
    ratings,
    reviews: {
      fetching: false,
      visibleCount: REVIEWS_DEFAULT_VISIBLE,
      data: reviews,
    },
    enqueue: {
      request_id: typeof requestId === 'string' ? requestId : null,
      search_params: search_params ? searchParamsDTO(search_params) : null,
    },
    images,
    pagination,
  };

  if (history) {
    middlewares.push(routerMiddleware(history));
  }

  const store = createStore(
    reducer,
    fromJS(preloadedState),
    composeEnhancers(responsiveStoreEnhancer, applyMiddleware(...middlewares)),
  );
  sagaMiddleware.run(sagas);
  return store;
};

export default getStore;
